import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
import ItemIntro from "@/components/ItemIntro.vue";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({});
let ScreenIntroAdv = class ScreenIntroAdv extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.advItems = [
            {
                text: "Активный отдых, новые знакомства и&nbsp;яркие эмоции",
                img: "/static/images/playing.png",
            },
            {
                text: "8&nbsp;шагов к&nbsp;вашему спокойствию",
                img: "/static/images/yoga.png",
            },
            {
                text: "20&nbsp;навыков для успешного будущего",
                img: "/static/images/winner.png",
            },
            {
                text: "Повышение мотивации к&nbsp;учебе и&nbsp;спорту",
                img: "/static/images/motivation.png",
            },
            { text: "Калейдоскоп событий", img: "/static/images/events.png" },
            {
                text: "Вкусное детское питание, одобренное Роспотребнадзором",
                img: "/static/images/healthy-food.png",
            },
        ];
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
    get isSm() {
        return this.breakpoint === "sm";
    }
    get itemsPerRow() {
        if (this.isXs)
            return 1;
        else if (this.isSm)
            return 2;
        else
            return 3;
    }
    get rowsAmount() {
        return this.advItems.length / this.itemsPerRow;
    }
};
ScreenIntroAdv = __decorate([
    Component({
        components: {
            ItemIntro,
        },
    })
], ScreenIntroAdv);
export default ScreenIntroAdv;
